import React, { useState,useEffect } from "react";
import ModalSearch from "../../ModalSearch";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useGetSkillsMutation, useUpdateProfileMutation } from "../../../store/appSlice";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import {isNil} from "lodash"
import { setProfileData } from "../../../reducers/userReducer";
 
function CandidateOverviewSkillsOnly() {
  const { user,profileData } = useAppSelector((state) => state["user"]);
  const [skillData,setSkillData]=useState(profileData?.skills??[])
  const [skillsModal,setSkillsModal]=useState(false)
  const [allSkills,setAllSkills]=useState([])
  const [onFirstRender,setFirstRender]=useState(true)
  const [getSkills, { data: skillsData }] =
  useGetSkillsMutation();
  const [updateProfile] = useUpdateProfileMutation();

  const dispatch=useAppDispatch()


  useEffect(()=>{ 
    onProfileDataChange()
  },[profileData])


const onProfileDataChange=()=>{

  if(!isNil(profileData)){
    setFirstRender(false)
    getAllSkills()
  }

  if(!isNil(profileData)){
    setSkillData(profileData?.skills??[])
  }

}

    

const getAllSkills=()=>{
  let professionIds=profileData?.professions.map((item)=>{
    return item.id
  })
// console.log(professionIds)
  const payload = {
    professionIds
  };
  getSkills(payload)
    .unwrap()
    .then((incomingData) => {
      // console.log({ incomingData });
      const newIncomingData = incomingData.map(({
        skillName: name,
        ...rest
      }) => ({
        name,
        ...rest
      }));
      setAllSkills(newIncomingData)
    })
    .catch((err) => { 
      console.log(err);
    });
}



const onSave=(selectedData,tempDataForReducer)=>{


  let dataForReducer=tempDataForReducer.map((item)=>{
    let obj={
      id:item.id,
    skillName:item.name
    }
    return obj
  })




  const payload = {
    skillIds:selectedData,
    param: user?.id,
  };

  updateProfile(payload)
    .unwrap()
    .then((incomingData) => { 
      dispatch(setProfileData({skills:[...dataForReducer]}));
      // console.log({specialityIds:incomingData})
    })
}



const onEditSkills=()=>{
  setSkillsModal(true) 
  } 

  return (
    <div className='container_sections_wrapper'>
      <div className="candidate-about__r6-skills-only" style={{display:'flex',flexDirection:'row'}}>
      <div>

        {<h3 style={{fontWeight:700}}>Skills</h3>} 

        {skillData?.length > 0 && (
          <div className="co-skills-only__skills-cont">
            {skillData.map((skill) => {
              return (
                <div key={skill.id} className="coso-skills-cont__ind-skill-div" >
                  <h4>{skill.skillName}</h4>
                </div>
              );
            })}
          </div>
        )}
       </div>
      </div>
   {skillsModal && (<ModalSearch subText={"Your skills"} dataList={allSkills} onDataSave={onSave} selectedData={profileData.skills} isVisible={skillsModal} selectionLimit={15} onClose={()=>setSkillsModal(!skillsModal)}/>)}

   <div onClick={ onEditSkills} className="add_icon"> <AddCircleOutlineIcon fontSize="large" style={{marginTop:'5px'}}/></div>

   </div>
  );
}

export default CandidateOverviewSkillsOnly;
